var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _path6, _path7, _g4, _path8, _path9, _path10, _g5, _path11, _g6, _path12, _g7, _path13, _g8, _path14, _g9, _path15, _g10, _path16, _g11, _path17, _path18, _g12, _path19, _g13, _path20, _path21, _path22, _path23, _path24, _g14, _path25, _g15, _path26, _g16, _path27, _path28, _g17, _path29, _g18, _path30;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequirementGatheringPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.182 13.4766C173.939 15.2335 175.654 16.9068 177.369 18.6219C179.336 20.5461 181.26 22.5122 183.226 24.4365C184.983 26.1934 186.781 27.9503 188.58 29.7909C186.196 29.7491 183.895 29.7073 181.678 29.6655C178.917 29.6236 176.24 29.5818 173.521 29.4563C173.061 29.4563 172.182 28.787 172.182 28.4523C172.182 27.6575 172.141 26.8627 172.141 26.0679C172.182 22.0521 172.182 17.9107 172.182 13.4766Z",
    fill: "#F9116C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 162,
    y: 13,
    width: 27,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M188.589 29.8066L178.466 32.7766C176.082 32.7348 173.781 32.693 171.564 32.6511C168.803 32.6093 166.126 32.5675 163.407 32.442C162.947 32.442 162.068 31.7727 162.068 31.438C162.068 30.6432 162.026 29.8484 162.026 29.0536C161.985 24.9959 162.026 20.8546 162.026 16.4622L172.149 13.4922C172.149 17.9264 172.108 22.0259 172.149 26.0835C172.149 26.8784 172.149 27.6732 172.191 28.468C172.191 28.8026 173.07 29.4719 173.53 29.4719C176.207 29.5556 178.884 29.5974 181.687 29.6811C183.946 29.7229 186.205 29.7647 188.589 29.8066Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.589 29.8066L178.466 32.7766C176.082 32.7348 173.781 32.693 171.564 32.6511C168.803 32.6093 166.126 32.5675 163.407 32.442C162.947 32.442 162.068 31.7727 162.068 31.438C162.068 30.6432 162.026 29.8484 162.026 29.0536C161.985 24.9959 162.026 20.8546 162.026 16.4622L172.149 13.4922C172.149 17.9264 172.108 22.0259 172.149 26.0835C172.149 26.8784 172.149 27.6732 172.191 28.468C172.191 28.8026 173.07 29.4719 173.53 29.4719C176.207 29.5556 178.884 29.5974 181.687 29.6811C183.946 29.7229 186.205 29.7647 188.589 29.8066Z",
    fill: "#7E0434"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 165,
    y: 66,
    width: 15,
    height: 9
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M177.874 71.9152L167.751 74.8852C167.918 74.8434 168.086 74.7597 168.169 74.6342C168.922 73.9231 169.717 72.8355 169.801 71.8734C169.884 70.5766 168.922 69.5726 167.5 69.4053C167.082 69.3634 166.663 69.3216 166.203 69.3216C165.952 69.3216 165.743 69.3216 165.492 69.3216L175.615 66.3516C175.866 66.3516 176.075 66.3516 176.326 66.3516C176.745 66.3516 177.163 66.3934 177.623 66.4352C179.045 66.6026 180.007 67.6065 179.924 68.9033C179.84 69.8654 179.045 70.9112 178.292 71.6642C178.209 71.7897 178.041 71.8733 177.874 71.9152Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.873 71.9219L167.75 74.8919H167.792L177.915 71.9219H177.873Z",
    fill: "#7E0434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.916 71.9202L167.793 74.8903C167.96 74.8485 168.086 74.7648 168.169 74.6811C168.922 73.97 169.717 72.8824 169.801 71.9202C169.884 70.6234 168.922 69.6195 167.5 69.4522C167.082 69.4103 166.663 69.3685 166.203 69.3685C165.952 69.3685 165.743 69.3685 165.492 69.3685L175.615 66.3984C175.866 66.3984 176.075 66.3984 176.326 66.3984C176.745 66.3984 177.163 66.4403 177.623 66.4821C179.045 66.6494 180.007 67.6534 179.924 68.9502C179.84 69.9123 179.045 70.9581 178.292 71.7111C178.209 71.7947 178.083 71.8784 177.916 71.9202Z",
    fill: "#7E0434"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 164,
    y: 125,
    width: 16,
    height: 10
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M177.877 131.349L167.754 134.319C169.05 133.943 169.761 133.065 169.803 131.81C169.845 130.053 168.506 128.965 166.122 128.923C165.997 128.923 165.829 128.923 165.704 128.923C165.411 128.923 165.16 128.923 164.867 128.923L174.99 125.953C175.283 125.953 175.534 125.953 175.827 125.953C175.952 125.953 176.12 125.953 176.245 125.953C178.629 126.037 179.968 127.083 179.926 128.84C179.884 130.094 179.173 130.973 177.877 131.349Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.865 131.354L167.742 134.324C167.784 134.324 167.826 134.283 167.868 134.283L177.991 131.312C177.991 131.312 177.907 131.354 177.865 131.354Z",
    fill: "#7E0434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.033 131.308L167.91 134.278C169.123 133.859 169.793 133.023 169.834 131.81C169.876 130.053 168.538 128.965 166.153 128.923C166.028 128.923 165.861 128.923 165.735 128.923C165.442 128.923 165.191 128.923 164.898 128.923L175.021 125.953C175.314 125.953 175.565 125.953 175.858 125.953C175.984 125.953 176.151 125.953 176.276 125.953C178.661 126.037 179.999 127.083 179.957 128.84C179.916 130.053 179.246 130.889 178.033 131.308Z",
    fill: "#7E0434"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M175.644 66.3881L165.521 69.3581L128.25 68.6888L138.373 65.7188L175.644 66.3881Z",
    fill: "#7E0434"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M174.975 125.904L164.852 128.832L128.125 128.204L138.248 125.234L174.975 125.904Z",
    fill: "#7E0434"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 45,
    width: 93,
    height: 10
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M178.122 51.8728L167.999 54.8428C169.296 54.4663 169.924 53.6715 169.965 52.4166C170.007 50.4923 168.585 49.4884 165.741 49.4465C140.726 49.0282 115.711 48.5681 90.6964 48.1497C89.7761 48.1497 89.0231 48.1916 88.4375 48.4007L98.5605 45.4307C99.1461 45.2634 99.8991 45.1797 100.819 45.1797C125.834 45.598 150.849 46.0582 175.864 46.4765C178.708 46.5183 180.13 47.5641 180.088 49.4465C180.047 50.7015 179.377 51.5381 178.122 51.8728Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.107 51.8778L167.984 54.8478C168.026 54.8478 168.068 54.806 168.152 54.806L178.275 51.8359C178.191 51.8778 178.149 51.8778 178.107 51.8778Z",
    fill: "#7E0434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.235 51.8309L168.112 54.801C169.283 54.4245 169.869 53.6297 169.911 52.4166C169.953 50.4923 168.53 49.4884 165.686 49.4465C140.671 49.0282 115.656 48.5681 90.6417 48.1497C89.7214 48.1497 88.9684 48.1916 88.3828 48.4007L98.5058 45.4307C99.0915 45.2634 99.8444 45.1797 100.765 45.1797C125.779 45.598 150.794 46.0582 175.809 46.4765C178.653 46.5183 180.076 47.5641 180.034 49.4465C180.034 50.6596 179.406 51.4545 178.235 51.8309Z",
    fill: "#7E0434"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M138.377 65.7134L128.254 68.6835L90.6484 68.056L100.73 65.0859L138.377 65.7134Z",
    fill: "#7E0434"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.498 12.3816L73.375 15.3517V13.0091L83.498 10.0391V12.3816Z",
    fill: "#7E0434"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 65,
    width: 13,
    height: 4
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2344 68.1686L98.3574 65.1986C98.5247 65.1567 98.7339 65.1149 98.943 65.0731C99.2777 65.0313 99.6541 65.0312 99.9888 65.0312C100.24 65.0312 100.491 65.0312 100.742 65.0312L90.6187 68.0013C90.3677 68.0013 90.1168 68.0013 89.8658 68.0013C89.5311 68.0013 89.1547 68.0013 88.82 68.0431C88.6109 68.0431 88.4435 68.085 88.2344 68.1686Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.742 65.0859L90.6187 68.056C90.3677 68.056 90.1168 68.056 89.8658 68.056C89.5311 68.056 89.1547 68.056 88.82 68.0978C88.6109 68.0978 88.4435 68.1397 88.2344 68.2233L98.3574 65.2533C98.5247 65.2114 98.7339 65.1696 98.943 65.1278C99.2777 65.0859 99.6541 65.0859 99.9888 65.0859C100.24 65.0859 100.491 65.0859 100.742 65.0859Z",
    fill: "#7E0434"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 84,
    width: 92,
    height: 11
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M178.092 91.717L167.969 94.6871C169.099 94.3524 169.768 93.4739 169.852 92.1353C169.977 90.7131 168.806 89.4163 167.3 89.2489C167.091 89.2071 166.882 89.2071 166.631 89.2071C166.38 89.2071 166.087 89.2071 165.836 89.2071C140.696 88.7888 115.556 88.3286 90.3736 87.9103C90.0808 87.9103 89.7461 87.8685 89.4533 87.8685C89.2023 87.8685 88.9513 87.8685 88.7422 87.9103L98.8652 84.9403C99.1162 84.8984 99.3253 84.8984 99.5763 84.8984C99.8691 84.8984 100.204 84.9403 100.497 84.9403C125.637 85.3586 150.777 85.8187 175.959 86.2371C176.21 86.2371 176.503 86.2371 176.754 86.2371C176.963 86.2371 177.214 86.2371 177.423 86.2789C178.929 86.4462 180.1 87.743 179.975 89.1653C179.891 90.4621 179.264 91.3824 178.092 91.717Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.076 91.7215L167.953 94.6916C167.995 94.6916 168.037 94.6497 168.079 94.6497L178.202 91.6797C178.16 91.6797 178.118 91.6797 178.076 91.7215Z",
    fill: "#7E0434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.207 91.6752L168.084 94.6452C169.172 94.2688 169.758 93.4321 169.883 92.1353C170.009 90.7131 168.837 89.4163 167.331 89.2489C167.122 89.2071 166.913 89.2071 166.662 89.2071C166.411 89.2071 166.118 89.2071 165.867 89.2071C140.727 88.7888 115.587 88.3286 90.4048 87.9103C90.112 87.9103 89.7774 87.8685 89.4846 87.8685C89.2336 87.8685 88.9826 87.8685 88.7734 87.9103L98.8965 84.9403C99.1474 84.8984 99.3566 84.8984 99.6076 84.8984C99.9004 84.8984 100.235 84.9403 100.528 84.9403C125.668 85.3586 150.808 85.8187 175.99 86.2371C176.241 86.2371 176.534 86.2371 176.785 86.2371C176.994 86.2371 177.245 86.2371 177.454 86.2789C178.96 86.4462 180.132 87.743 180.006 89.1653C179.881 90.4202 179.295 91.2987 178.207 91.6752Z",
    fill: "#7E0434"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 84,
    width: 11,
    height: 4
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3984 87.9522L98.5215 84.9821C98.6469 84.9403 98.7724 84.8984 98.8979 84.8984L88.7749 87.8685C88.6494 87.9103 88.5239 87.9522 88.3984 87.9522Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.8979 84.9453L88.7749 87.9154C88.6494 87.9572 88.5239 87.9572 88.3984 87.999L98.5215 85.029C98.6469 84.9871 98.7724 84.9453 98.8979 84.9453Z",
    fill: "#7E0434"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 104,
    width: 92,
    height: 11
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M178.053 111.4L167.93 114.37C169.102 114.035 169.813 113.157 169.855 111.944C169.938 110.27 168.642 109.057 166.592 108.932C166.466 108.932 166.341 108.932 166.215 108.932C166.048 108.932 165.839 108.932 165.672 108.932C140.573 108.513 115.517 108.053 90.4182 107.635C90.209 107.635 89.9999 107.635 89.7907 107.635C89.4142 107.635 89.0378 107.635 88.7031 107.719L98.8261 104.749C99.1608 104.665 99.5373 104.623 99.9137 104.665C100.123 104.665 100.332 104.665 100.541 104.665C125.64 105.083 150.696 105.501 175.795 105.962C175.962 105.962 176.171 105.962 176.338 105.962C176.464 105.962 176.589 105.962 176.715 105.962C178.723 106.087 180.061 107.3 179.978 108.974C179.936 110.187 179.225 111.065 178.053 111.4Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.045 111.393L167.922 114.363C167.964 114.363 168.006 114.322 168.047 114.322L178.17 111.352C178.129 111.352 178.087 111.393 178.045 111.393Z",
    fill: "#7E0434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.176 111.358L168.053 114.328C169.183 113.951 169.81 113.115 169.894 111.944C169.977 110.27 168.681 109.057 166.631 108.932C166.505 108.932 166.38 108.932 166.254 108.932C166.087 108.932 165.878 108.932 165.711 108.932C140.612 108.513 115.556 108.053 90.4572 107.635C90.2481 107.635 90.0389 107.635 89.8298 107.635C89.4533 107.635 89.0768 107.635 88.7422 107.719L98.8652 104.749C99.1999 104.665 99.5763 104.623 99.9528 104.665C100.162 104.665 100.371 104.665 100.58 104.665C125.679 105.083 150.735 105.501 175.834 105.962C176.001 105.962 176.21 105.962 176.377 105.962C176.503 105.962 176.628 105.962 176.754 105.962C178.762 106.087 180.1 107.3 180.017 108.974C179.933 110.145 179.264 110.981 178.176 111.358Z",
    fill: "#7E0434"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 124,
    width: 51,
    height: 5
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1094 127.723L98.2324 124.753C98.3997 124.711 98.6089 124.67 98.818 124.628C99.2782 124.586 99.7801 124.586 100.24 124.586C100.449 124.586 100.617 124.586 100.826 124.586C113.291 124.795 125.799 125.004 138.264 125.213L128.141 128.183C115.676 127.974 103.168 127.765 90.7029 127.556C90.4937 127.556 90.3264 127.556 90.1172 127.556C89.6571 127.556 89.1551 127.556 88.695 127.598C88.4859 127.64 88.3185 127.681 88.1094 127.723Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.264 125.252L128.141 128.223C115.676 128.013 103.168 127.804 90.7029 127.595C90.4937 127.595 90.3264 127.595 90.1172 127.595C89.6571 127.595 89.1551 127.595 88.695 127.637C88.4859 127.637 88.2767 127.679 88.1094 127.762L98.2324 124.792C98.3997 124.75 98.6089 124.709 98.818 124.667C99.2782 124.625 99.7801 124.625 100.24 124.625C100.449 124.625 100.617 124.625 100.826 124.625C113.333 124.834 125.799 125.085 138.264 125.252Z",
    fill: "#7E0434"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 12,
    width: 11,
    height: 74
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3808 82.4014L73.2578 85.3714C73.2996 61.862 73.3415 38.6035 73.3833 15.3451L83.5063 12.375C83.4645 35.6335 83.4227 58.8919 83.3808 82.4014Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.3808 82.4014L73.2578 85.3714C73.2996 61.862 73.3415 38.6035 73.3833 15.3451L83.5063 12.375C83.4645 35.6335 83.4227 58.8919 83.3808 82.4014Z",
    fill: "#7E0434"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 82,
    width: 11,
    height: 5
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3808 83.3187L73.2578 86.2888C73.2578 85.996 73.2578 85.6613 73.2578 85.3685L83.3808 82.3984C83.3808 82.6913 83.3808 83.0259 83.3808 83.3187Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.3808 83.3187L73.2578 86.2888C73.2578 85.996 73.2578 85.6613 73.2578 85.3685L83.3808 82.3984C83.3808 82.6913 83.3808 83.0259 83.3808 83.3187Z",
    fill: "#7E0434"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3418 97.9614L73.2188 100.89L73.2606 86.2904L83.3836 83.3203L83.3418 97.9614Z",
    fill: "#7E0434"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 97,
    width: 11,
    height: 24
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3418 117.039L73.2188 120.009C73.2188 113.902 73.2606 107.836 73.2606 101.729C73.2606 101.436 73.2606 101.185 73.2606 100.892L83.3836 97.9219C83.3836 98.2147 83.3836 98.4657 83.3836 98.7585C83.3418 104.866 83.3418 110.932 83.3418 117.039Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.3418 117.039L73.2188 120.009C73.2188 113.902 73.2606 107.836 73.2606 101.729C73.2606 101.436 73.2606 101.185 73.2606 100.892L83.3836 97.9219C83.3836 98.2147 83.3836 98.4657 83.3836 98.7585C83.3418 104.866 83.3418 110.932 83.3418 117.039Z",
    fill: "#7E0434"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 117,
    width: 11,
    height: 36
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M83.248 149.281L73.125 152.251C73.125 141.5 73.1668 130.791 73.1668 120.04L83.2898 117.07C83.2898 127.821 83.2899 138.53 83.248 149.281Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.248 149.281L73.125 152.251C73.125 141.5 73.1668 130.791 73.1668 120.04L83.2898 117.07C83.2898 127.821 83.2899 138.53 83.248 149.281Z",
    fill: "#7E0434"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M191.799 153.351L181.676 156.321L73.125 154.397L83.248 151.469L191.799 153.351Z",
    fill: "#7E0434"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M83.248 151.467L73.125 154.395V152.178L83.248 149.25V151.467Z",
    fill: "#7E0434"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M190.504 35.5592C191.006 35.5592 191.466 35.5592 192.01 35.601L191.801 153.357L83.25 151.475V149.258C83.25 138.507 83.2918 127.798 83.2918 117.047C83.2918 110.94 83.3337 104.874 83.3337 98.767C83.3337 98.4742 83.3337 98.2232 83.3337 97.9304L83.3755 83.2892C83.3755 82.9964 83.3755 82.6618 83.3755 82.3689C83.4173 58.8595 83.4591 35.601 83.501 12.3426V10L166.66 11.4641C166.66 12.2171 166.66 12.8864 166.66 13.5557C166.66 18.5337 166.619 23.4698 166.66 28.4478C166.702 32.2545 169.003 34.8899 172.684 35.0572C178.373 35.35 184.062 35.35 189.751 35.5174C190.002 35.5592 190.253 35.5592 190.504 35.5592ZM175.863 52.1246C178.624 52.1664 180.004 51.2879 180.046 49.4473C180.088 47.5231 178.666 46.5191 175.821 46.4773C150.807 46.059 125.792 45.5988 100.777 45.1805C97.9744 45.1387 96.6776 45.9753 96.594 47.8577C96.5103 49.8238 97.8489 50.7441 100.777 50.786C104.918 50.8696 109.06 50.9115 113.201 50.9951C121.483 51.1206 129.766 51.2879 138.048 51.4134C146.456 51.5808 154.864 51.7481 163.23 51.8736C167.497 51.9991 171.68 52.0409 175.863 52.1246ZM176.156 131.563C178.54 131.605 179.921 130.601 179.963 128.844C180.004 127.087 178.666 125.999 176.281 125.958C176.156 125.958 175.989 125.958 175.863 125.958C175.57 125.958 175.319 125.958 175.026 125.958L138.299 125.33C125.834 125.121 113.326 124.912 100.861 124.703C100.652 124.703 100.484 124.703 100.275 124.703C99.8149 124.703 99.313 124.703 98.8528 124.745C97.4306 124.87 96.6776 125.79 96.5522 127.171C96.4267 128.551 97.0541 129.639 98.3927 130.015C99.1875 130.266 100.066 130.308 100.903 130.308C114.205 130.559 127.465 130.768 140.767 131.019C147.418 131.145 154.069 131.27 160.679 131.354C164.694 131.438 168.668 131.521 172.684 131.563C173.855 131.521 174.985 131.521 176.156 131.563ZM98.8947 84.9207C97.3888 85.2135 96.5103 86.1756 96.594 87.7652C96.6358 89.2294 97.5143 90.1915 98.9365 90.4425C99.1457 90.4843 99.3966 90.4843 99.6476 90.4843C99.9404 90.4843 100.275 90.4843 100.568 90.4843L138.216 91.1536L176.03 91.8229C176.323 91.8229 176.616 91.8648 176.867 91.8648C177.076 91.8648 177.285 91.8648 177.453 91.8229C179 91.6556 179.837 90.6935 179.963 89.1457C180.088 87.7234 178.917 86.4266 177.411 86.2593C177.202 86.2175 176.993 86.2175 176.742 86.2175C176.491 86.2175 176.198 86.2175 175.947 86.2175C150.807 85.7992 125.666 85.339 100.484 84.9207C100.191 84.9207 99.8568 84.8788 99.564 84.8788C99.3966 84.837 99.1457 84.8789 98.8947 84.9207ZM122.905 110.647C127.967 110.731 133.028 110.815 138.09 110.898C144.532 111.024 150.932 111.149 157.374 111.233C163.816 111.317 170.216 111.442 176.658 111.568C178.666 111.609 179.879 110.605 179.963 108.974C180.046 107.301 178.749 106.088 176.7 105.962C176.574 105.962 176.449 105.962 176.323 105.962C176.156 105.962 175.947 105.962 175.779 105.962C150.681 105.544 125.624 105.084 100.526 104.665C100.317 104.665 100.108 104.665 99.8986 104.665C99.3548 104.665 98.811 104.665 98.4345 104.916C97.6816 105.376 96.845 106.171 96.6776 106.966C96.5521 107.761 96.9705 108.974 97.5561 109.56C98.0999 110.103 99.2293 110.187 100.108 110.229C107.721 110.396 115.334 110.522 122.905 110.647ZM96.6776 67.3513C96.4685 68.6481 96.9705 69.7358 98.1417 70.2796C98.811 70.6142 99.6476 70.6979 100.442 70.6979C115.25 70.9489 130.059 71.2417 144.825 71.4927C155.282 71.66 165.74 71.8692 176.24 72.0365C176.365 72.0365 176.532 72.0365 176.7 72.0365C177.327 72.0365 177.996 72.0365 178.331 71.7018C179.084 70.9907 179.879 69.9031 179.963 68.941C180.046 67.6442 179.084 66.6402 177.662 66.4729C177.244 66.431 176.825 66.3892 176.365 66.3892C176.114 66.3892 175.905 66.3892 175.654 66.3892L138.383 65.7199L100.735 65.0924C100.484 65.0924 100.233 65.0924 99.9823 65.0924C99.6476 65.0924 99.2711 65.0924 98.9365 65.1343C97.6397 65.2179 96.8868 66.0546 96.6776 67.3513Z",
    fill: "#F9116C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9345 29.4062V31.7488C77.8926 48.5234 77.8508 65.2561 77.8508 82.0306L77.7671 116.876C77.7253 128.213 77.7253 139.507 77.7253 150.844C77.7253 155.404 79.3985 157.202 83.8326 157.286L131.603 158.123C111.483 161.553 91.3203 164.774 70.9487 168.037C63.5447 123.193 56.2243 78.7259 48.8203 33.9659C58.525 32.46 68.1461 30.954 77.9345 29.4062Z",
    fill: "#F9116C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 33,
    width: 33,
    height: 138
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9702 168.013L60.8472 170.983C53.4431 126.14 46.1228 81.6726 38.7188 36.9544L48.8418 33.9844C56.2458 78.7444 63.5662 123.212 70.9702 168.013Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.9702 168.013L60.8472 170.983C53.4431 126.14 46.1228 81.6726 38.7188 36.9544L48.8418 33.9844C56.2458 78.7444 63.5662 123.212 70.9702 168.013Z",
    fill: "#7E0434"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 158,
    width: 72,
    height: 13
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M131.621 158.062L121.498 161.033C101.378 164.463 81.2153 167.684 60.8438 170.947L70.9668 167.977C91.3383 164.714 111.501 161.493 131.621 158.062Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.621 158.062L121.498 161.033C101.378 164.463 81.2153 167.684 60.8438 170.947L70.9668 167.977C91.3383 164.714 111.501 161.493 131.621 158.062Z",
    fill: "#7E0434"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 140,
    width: 27,
    height: 50
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7329 186.846L51.6098 189.816C51.317 189.063 51.0661 188.561 50.8987 188.059C45.7536 173.251 40.6502 158.526 35.5469 143.759L45.6699 140.789C50.7732 155.556 55.9184 170.28 61.0217 185.047C61.1891 185.591 61.4401 186.093 61.7329 186.846Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.7329 186.846L51.6098 189.816C51.317 189.063 51.0661 188.561 50.8987 188.059C45.7536 173.251 40.6502 158.526 35.5469 143.759L45.6699 140.789C50.7732 155.556 55.9184 170.28 61.0217 185.047C61.1891 185.591 61.4401 186.093 61.7329 186.846Z",
    fill: "#7E0434"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7069 140.843L35.5838 143.772L24.1641 110.85L34.2871 107.922L45.7069 140.843Z",
    fill: "#7E0434"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 58,
    width: 28,
    height: 53
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2736 107.935L24.1506 110.863C19.8838 98.6061 15.7008 86.684 11.5595 74.762C10.0955 70.4115 8.58957 66.061 7 61.5013L17.123 58.5312C18.7126 63.0491 20.2185 67.4414 21.7244 71.7919C25.8656 83.7558 30.0069 95.6779 34.2736 107.935Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2736 107.935L24.1506 110.863C19.8838 98.6061 15.7008 86.684 11.5595 74.762C10.0955 70.4115 8.58957 66.061 7 61.5013L17.123 58.5312C18.7126 63.0491 20.2185 67.4414 21.7244 71.7919C25.8656 83.7558 30.0069 95.6779 34.2736 107.935Z",
    fill: "#7E0434"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 49,
    width: 39,
    height: 13
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M17.123 58.5767L7 61.5049C16.5792 58.3257 25.9911 55.1883 35.5703 52.0091L45.6934 49.0391C36.1141 52.2601 26.7022 55.3975 17.123 58.5767Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.123 58.5767L7 61.5049C16.5792 58.3257 25.9911 55.1883 35.5703 52.0091L45.6934 49.0391C36.1141 52.2601 26.7022 55.3975 17.123 58.5767Z",
    fill: "#7E0434"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6903 49.0547C46.7361 55.4549 47.7818 61.4787 48.7439 67.5443C50.8355 80.2612 52.927 92.978 55.0604 105.695C57.1519 118.412 59.2434 131.129 61.3768 143.845C62.799 152.421 64.1795 160.955 65.6854 169.53C66.1455 172.124 67.986 173.713 70.2867 173.755C70.5796 173.755 70.9142 173.755 71.207 173.671C84.1327 171.664 97.0584 169.572 109.984 167.522C113.33 166.978 116.677 166.476 120.023 165.933C100.698 173.086 81.2464 179.904 61.7533 186.765C61.4605 186.012 61.2095 185.51 61.0422 185.008C55.9388 170.241 50.7936 155.517 45.6903 140.75L34.2705 107.912C30.0038 95.6553 25.8207 83.7332 21.6795 71.8112C20.1736 67.4607 18.6677 63.0683 17.0781 58.5505C26.6992 55.3713 36.1111 52.2339 45.6903 49.0547Z",
    fill: "#F9116C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequirementGatheringPink);
export default __webpack_public_path__ + "static/media/requirement-gathering-pink.fb2b4300b84ef6b397b6d0cfb7adf51b.svg";
export { ForwardRef as ReactComponent };